import { Button } from '@neo/primitives/button'
import { useSidebar } from '@neo/primitives/sidebar'
import { PanelLeft } from 'lucide-react'

export const SidebarToggle = () => {
  const { state, toggleSidebar, isMobile, openMobile } = useSidebar()
  const label = isMobile
    ? openMobile
      ? 'Close navigation'
      : 'Open navigation'
    : state === 'collapsed'
      ? 'Expand sidebar'
      : 'Collapse sidebar'
  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-8 shrink-0 text-secondary"
      onClick={toggleSidebar}
      aria-label={label}
      title={label}
      data-testid="sidebar-toggle"
    >
      <PanelLeft className="size-4" strokeWidth={1.75} />
    </Button>
  )
}
